module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.8193/js/img/ServiceHub_Icon.svg"